import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom' // Import useNavigate
import '../styles/scenario.scss'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { DateTime } from 'luxon'
import { useAuth } from '../../auth'
import { deleteScenario, updateScenarioStatus } from '../core/_requests'
import { DeleteConfirmationModal } from './DeleteConfirmationModal'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { useThemeMode } from '../../../../_metronic/partials'

const ScenarioDataCard = ({ scenarioDetails, currentValuation, getSenarios }: any) => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const navigate = useNavigate() // Initialize useNavigate
  const [isChecked, setIsChecked] = useState(false)
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const { companyId, currentUser } = useAuth()
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)

  const deleteScenarioDetails = async () => {
    setDeleteLoading(true)
    try {
      const {
        data: { success },
      } = await deleteScenario(companyId!, scenarioDetails.scenarioId!)
      if (success) {
        getSenarios()
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDeleteShowModal(false)
      setDeleteLoading(false)
    }
  }
  const handleToggleChange = async () => {
    try {
      setIsChecked(!isChecked)
      if (!scenarioDetails || !scenarioDetails.scenarioId) {
        console.error('Scenario details or scenarioId is missing.')
        return
      }
      const rawPayload: any = {
        scenarioId: scenarioDetails.scenarioId,
        status: !isChecked,
      }
      const {
        data: { data, success },
      } = await updateScenarioStatus(companyId!, rawPayload)
      if (success) {
        console.log(data)
      } else {
        setIsChecked(!isChecked)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleViewDetails = () => {
    if (scenarioDetails) {
      navigate(`financial-details/${scenarioDetails.scenarioId}`)
    }
  }

  useEffect(() => {
    if (scenarioDetails) {
      setIsChecked(scenarioDetails.status)
    }
  }, [scenarioDetails])
  console.log(companyId, 'comapanyid')
  console.log(currentUser, 'current user')
  return (
    <>
      <div className='bg-white p-4 scenario-card-width w-md-auto w-100 mb-4 mb-md-auto rounded'>
        <div className='d-flex align-items-center justify-content-between mb-4'>
          <h5 className='form-check-label m-0 text-dark'>{scenarioDetails?.scenarioName}</h5>
          <div className='d-flex align-items-center'>
            <label className='toggle'>
              <input
                className='toggle__input'
                name='toggle-input'
                type='checkbox'
                checked={isChecked}
                onChange={handleToggleChange}
              />
              <div className='toggle__fill'></div>
            </label>
            <div className='position-relative align-self-center'>
              <div
                className='p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-center'
                onClick={() => {
                  setShowKebabMenu(!showKebabMenu)
                }}
              >
                <img src={threeDots} alt='' width={15} height={15} />
              </div>
              {showKebabMenu && (
                <div
                  className='card shadow rounded top-4 cursor-pointer z-index-1 position-absolute w-150px'
                  style={{ top: '40px', right: 0 }}
                  ref={dropdownRef}
                >
                  <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100 bg-hover-secondary rounded-top'
                    onClick={handleViewDetails}>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent text-primary font-size-12'
                    >
                      {formatMessage({ id: 'View' })}
                    </button>
                  </div>
                  <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100 bg-hover-secondary'
                    onClick={() => navigate(`../scenarios/update/${scenarioDetails.scenarioId}`)}>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent text-dark font-size-12'
                    >
                      {formatMessage({ id: 'Edit' })}
                    </button>
                  </div>
                  <div className=' border-gray-300 border-0 p-2 dropdown-items w-100  bg-hover-secondary rounded-bottom'
                    onClick={() => setDeleteShowModal(true)}>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent text-danger font-size-12 bg-hover-muted'
                    >
                      {formatMessage({ id: 'Delete' })}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div className='my-2'> */}
        {/* <span className={`text-white ${type === 'Waterfall' ? 'badge bg-primary' : 'badge bg-warning'}`}>{type}</span> */}
        {/* </div> */}
        <div className='d-flex mb-4'>
          <div className='d-flex flex-column justify-content-around w-100 gap-4'>
            <div className='d-flex flex-column gap-2'>
              <p className='mb-0'>{formatMessage({ id: 'Entry Date' })}</p>
              <h5 className='mb-0'>
                {DateTime.fromISO(scenarioDetails?.entryDate).toFormat('MMM d, yyyy')}
              </h5>
            </div>
            <div className='d-flex flex-column gap-2'>
              <p className='mb-0'>{formatMessage({ id: 'Exit Date' })}</p>
              <h5 className='mb-0'>
                {DateTime.fromISO(scenarioDetails?.exitDate).toFormat('MMM d, yyyy')}
              </h5>
            </div>
          </div>
          <div className='d-flex flex-column justify-content-around w-100 gap-4'>
            <div className='d-flex flex-column gap-2'>
              <p className='mb-0'>{formatMessage({ id: 'Entry Value' })}</p>
              <h5 className='mb-0'>{currentValuation}</h5>
            </div>
            <div className='d-flex flex-column gap-2'>
              <p className='mb-0'>{formatMessage({ id: 'Exit Value' })}</p>
              <h5 className='mb-0'>{currentValuation + scenarioDetails?.newInvestment}</h5>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column gap-2'>
          <p className='mb-0'>{formatMessage({ id: 'Created By' })}</p>
          <div className='d-flex align-items-center justify-content-start gap-2'>
            <DisplayImage imgName={currentUser?.profileImg} alt={''} height={24} width={24} className='rounded-circle' />
            <h5 className='mb-0 fw-normal'>
              {scenarioDetails?.user
                ? `${scenarioDetails.user.firstName} ${scenarioDetails.user.lastName}`
                : '-'}
            </h5>{' '}
          </div>
        </div>
        <div className='my-2' style={{ border: mode === 'dark' ? '#565674 1px solid' : '#F4F4F4 1px solid' }}></div>
        <div>
          <button className='btn btn-light w-100' onClick={handleViewDetails}>
            {formatMessage({ id: 'View Details' })}
          </button>
        </div>
      </div>
      <DeleteConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteScenarioDetails}
        deleteLoading={deleteLoading}
        header='Delete Scenario'
        paragraph='Are you sure you want to delete this scenario?'
      />
    </>
  )
}

export default ScenarioDataCard
